import React from 'react';
import { useBallparkContext, useCurrentUser, userSelectors, } from '@marvelapp/marvel-3-application';
import { colors } from '@marvelapp/theme';
import { Badge, Box, Flex, Heading, Radio, Semibold, Shake, Text, hexToRGB, } from '@marvelapp/ui';
import ExternalLink from '../ExternalLink';
import Link from '../Link';
import TooltipWrap from '../TooltipWrap';
import UserRoleSelect from '../UserRoleSelect';
import { ballparkCopy, copy, testIds } from './copy';
export default function RoleRow({ extraDescription, atRoleLimit, isRowSelected = false, learnMoreUrl, maxAllowance, onRadioClick, onRoleChange, pendingTotalSeats, pricePerUser, readOnly = false, roleOptions, roleSelectDirection = 'bottom', roleType, seatsUsed, selectedRole, }) {
    const isBallpark = useBallparkContext();
    const user = useCurrentUser();
    const canInviteContributors = !(isBallpark &&
        (userSelectors.isFree(user) || userSelectors.isPro(user)));
    const { testId, radioTestId } = testIds[roleType];
    const { name: marvelName, description: marvelDescription, role: marvelRole, } = copy[roleType];
    const { name: ballparkName, description: ballparkDescription, role: ballparkRole, } = ballparkCopy[roleType];
    const name = isBallpark ? ballparkName : marvelName;
    const description = isBallpark ? ballparkDescription : marvelDescription;
    const role = isBallpark ? ballparkRole : marvelRole;
    const seatsUsedToShow = isRowSelected ? pendingTotalSeats : seatsUsed;
    return (React.createElement(Flex, { alignItems: ['flex-start', 'center'], bg: isRowSelected ? hexToRGB(colors.silver, 0.05) : 'transparent', borderTop: "1px solid", 
        // eslint-disable-next-line
        borderColor: "smoke", "data-testid": testId, flexDirection: ['column', 'row'], padding: 30, transition: "smooth.fast" },
        React.createElement(Box, null,
            React.createElement(Flex, { alignItems: "center" },
                React.createElement(Heading, { fontSize: 3, fontWeight: 500 }, name),
                maxAllowance && !isBallpark && (React.createElement(Box, { "data-testid": "seats-count", marginLeft: 2, paddingBottom: "1px" },
                    React.createElement(Shake, { shouldShake: atRoleLimit && isRowSelected },
                        React.createElement(Badge, { bg: "white", kind: "ghost", size: 1 },
                            seatsUsedToShow,
                            " of ",
                            maxAllowance,
                            " seats used"))))),
            React.createElement(Text, { fontSize: 14, marginTop: 2 },
                description,
                ' ',
                learnMoreUrl && (React.createElement(ExternalLink, { href: learnMoreUrl }, "Learn more"))),
            extraDescription && (React.createElement(Text, { fontSize: 14, marginTop: 2 }, extraDescription)),
            isRowSelected && pendingTotalSeats > seatsUsed && !isBallpark && (React.createElement(Text, { fontSize: 2, marginTop: 2 }, pricePerUser))),
        React.createElement(Flex, { alignItems: "center", flexDirection: ['row-reverse', 'row'], justifyContent: "flex-end", marginTop: [2, 0], minWidth: 120 },
            React.createElement(UserRoleSelect, { disabled: readOnly, isReversed: roleSelectDirection === 'top', onSelection: onRoleChange, options: roleOptions, selectedRole: selectedRole }),
            React.createElement(TooltipWrap, { content: React.createElement(Text, { fontSize: 1, fontWeight: 500 }, getTooltipText({
                    maxAllowance,
                    readOnly,
                    seatsUsed,
                    name,
                    role,
                    canInviteContributors,
                })), showTooltip: readOnly },
                React.createElement(Radio, { "data-testid": radioTestId, isChecked: isRowSelected, isDisabled: readOnly, kind: "defaultBlue", name: "role", onChange: () => onRadioClick(), readOnly: readOnly, size: 20 })))));
}
function getTooltipText({ maxAllowance, readOnly, seatsUsed, name, role, canInviteContributors, }) {
    if (readOnly) {
        if (!canInviteContributors) {
            return (React.createElement(React.Fragment, null,
                name,
                "s are not available on your plan. Please",
                ' ',
                React.createElement(Link, { kind: "white", target: "_blank", to: "/plans?intent=more-user-roles" }, "upgrade"),
                ' ',
                "to get access to ",
                role,
                "s."));
        }
        return (React.createElement(React.Fragment, null,
            "You can only add up to ",
            React.createElement(Semibold, null, maxAllowance),
            " ",
            role,
            " to your account.",
            ' ',
            seatsUsed >= maxAllowance
                ? `Remove ${role} before trying to add more.`
                : `Remove some emails to be able to switch to adding ${role}.`));
    }
}
